const LATIN_CHARACTERS_PATTERN = /^[a-zA-Z0-9!#$%&*()\-+=._?/ '\u2019\u00C0-\u00FF\u0152\u0153]+$/u;

const latinCharactersMessage =
  'From Name can only contain alphanumeric characters, accented letters (French/Spanish), apostrophes, and the following symbols: ! # $ % & * ( ) - + = . _ ? / .';

function latinCharacters(value: string): string | undefined {
  if (!value) {
    return undefined;
  }
  return LATIN_CHARACTERS_PATTERN.test(value) ? undefined : `^${latinCharactersMessage}`;
}

export default latinCharacters;
